/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { MyProfileWidgetMode } from '../enums/myprofile-widget-mode'

export class SetAppLoadingStatus {
  static readonly type = '[phone-widget] set app loading status'

  constructor(public loading: boolean) {}
}

export class SetInitialConfiguration {
  static readonly type = '[phone-widget] set locale'

  constructor(
    public mode: MyProfileWidgetMode,
    public country: string,
    public locale: string,
    public token: string,
  ) {}
}

export class GetTranslations {
  static readonly type = '[phone-widget] get translations'
}

export class SetAppErrorMessage {
  static readonly type = '[phone-widget] set Error Message'

  constructor(public errorMessage: string | null) {}
}

export class SetEditorErrorMessage {
  static readonly type = '[phone-widget] set editor error message'

  constructor(public errorMessage: string | null) {}
}

export class GetMfaInformation {
  static readonly type = '[phone-widget] get mfa information'
}
